export default {
  buttonText: "Enable Push Notifications",
  message: "Get real-time updates delivered straight to your device!",
  title: "Stay on Top of the Action"
};
